// alternative implementation
/*let store_lateAlias: RootState;
OnStoreLoaded(store=>{
	store_lateAlias = store;
});
export function GetStore_Late() {
	Assert(store_lateAlias != null, "Store not initialized yet!");
	return store_lateAlias;
}*/

/** NOTE: Only call this function from places that are called "late" (ie. after initial execution run in each JS module), and where doing so is needed to avoid an import-loop. (or in modules/contexts prone to those) */
export function GetStore_Late() {
	// eslint-disable-next-line
	const {store} = require("./index.js") as typeof import("./index.js"); // late-require, avoiding circular importing
	return store;
}